import type { AppProps } from 'antd';

export const appNotificationConfig = {
  placement: 'bottomRight',
  bottom: 8,
} satisfies NonNullable<AppProps['notification']>;
